import { OFFER_KIND } from '../../../../../../views/menu/offers/constants';

export default {
  title: 'Detalles de la oferta',
  types: {
    [OFFER_KIND.PERCENTAGE_OFF_BY_MIN_SPEND_VALUE]: {
      title: 'Establece el gasto mínimo y el % de descuento',
      qualifying_criteria: {
        title: 'Importe mínimo de gasto',
        description: 'Establece el importe mínimo de gasto',
      },
      details: {
        title: '% de descuento',
        description: 'Establece el descuento que los clientes obtendrán en su pedido',
      },
    },
    [OFFER_KIND.PERCENTAGE_OFF_BY_PRODUCTS]: {
      title: 'Establece el gasto en artículos y el % de descuento',
      qualifying_criteria: {
        title: 'Artículos con descuento',
        description: 'Selecciona los artículos a los que ofreces descuento.',
      },
      details: {
        title: '% de descuento',
        description: 'Establece el descuento que los clientes obtendrán en su pedido',
      },
    },
    [OFFER_KIND.AMOUNT_OFF_BY_PRODUCTS]: {
      title: 'Establece los artículos y el descuento en {{currency}}',
      qualifying_criteria: {
        title: 'Artículos con descuento',
        description: 'Selecciona los artículos a los que ofreces descuento.',
      },
      details: {
        title: 'Descuento en {{currency}}',
        description: 'Establece el descuento que los clientes obtendrán en su pedido',
      },
    },
    [OFFER_KIND.AMOUNT_OFF_BY_MIN_SPEND_VALUE]: {
      title: 'Establece el gasto mínimo y el descuento en {{currency}}',
      qualifying_criteria: {
        title: 'Importe mínimo de gasto',
        description: 'Establece el importe mínimo de gasto',
      },
      details: {
        title: 'Descuento en {{currency}}',
        description: 'Establece el descuento que los clientes obtendrán en su pedido',
      },
    },
    [OFFER_KIND.FREE_ITEM_BY_MIN_SPEND_VALUE]: {
      title: 'Establece el gasto mínimo y los artículos gratuitos',
      qualifying_criteria: {
        title: 'Importe mínimo de gasto',
        description: 'Establece el importe que el cliente debe gastar para obtener el artículo gratis.',
      },
      details: {
        title: 'Artículos gratuitos:',
        description: 'Selecciona el artículo (o artículos) gratuito del que el cliente puede elegir uno.',
      },
    },
    [OFFER_KIND.FREE_ITEM_BY_PRODUCTS]: {
      title: 'Elige los requisitos de la oferta',
      qualifying_criteria: {
        title: 'Artículos requeridos',
        description: 'Selecciona los artículos que el cliente debe pedir para obtener el artículo gratuito.',
      },
      details: {
        title: 'Artículos gratuitos:',
        description: 'Selecciona el artículo (o artículos) gratuito del que el cliente puede elegir uno.',
      },
    },
    [OFFER_KIND.BOGO]: {
      title: 'Elige los requisitos de la oferta',
      qualifying_criteria: {
        title: 'Artículos requeridos',
        description: 'Selecciona la categoría de la que el cliente debe elegir para obtener un artículo gratuito.',
      },
      details: {
        title: 'Artículo gratuito',
        description:
          'Los clientes pueden seleccionar su segundo artículo de los artículos requeridos que has elegido. El cliente obtendrá gratis el más barato de los dos artículos.',
      },
    },
  },
};
